import React from "react"
import Link from "~components/Link"
import * as style from "./More.module.scss"

const More = ({ to, right, children, secondary }) => (
  <div className={`${style.more} ${secondary ? style.secondary : ''}`} data-align-right={right === ""}>
    <Link to={to}>
      {children}
    </Link>
  </div>
)

export default More
